import { TagService } from './tag.service'
import { Project } from './project'
import { DbRecord } from './db-record'

export class Tag {
  private _title: string
  taggedItems = new Set<string>()

  constructor(
    private tags: TagService,
    public project: Project,
    public id: string,
    title: string,
    taggedItemsLs?: string[]
  ) {
    this._title = title
    this.project.tagsMap.set(this.id, this)

    if (taggedItemsLs)
      this.taggedItems = new Set<string>(taggedItemsLs)
  }


  set title(txt) {
    this._title = txt.trim()
  }

  get title() {
    return this._title
  }


  isSelected(dbRecord: DbRecord) {
    return this.taggedItems.has(dbRecord.id)
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/tag.ts